import request from '@/utils/request'
// 签到
export function commitCheckin() {
  return request({
    url: '/hr/checkinrecord/commit',
    method: 'POST'
  })
}
// 获取签到情况
export function getCheckinrecord (year, month) {
  return request({
    url: `/hr/checkinrecord/month/${year}/${month}`,
    method: 'GET'
  })
}

// 获取积分商城商品
export function getGoodList (params) {
  return request({
    url: '/hr/pointsproduct/page',
    method: 'GET',
	params
  })
}

// 获取个人地址列表
export function getAddressList () {
  return request({
    url: '/hr/deliveryaddress/fetchAll',
    method: 'GET'
  })
}
// 获取兑换记录
export function getRecord (params) {
  return request({
    url: '/hr/exchangerecord/selfPage',
    method: 'GET',
	params
  })
}
// 添加个人地址
export function setAddress (data) {
  return request({
    url: '/hr/deliveryaddress/commit',
    method: 'POST',
	data
  })
}
// 提交兑换申请
export function commitApply (data) {
  return request({
    url: '/hr/exchangerecord/commit',
    method: 'POST',
	data
  })
}

// 获取兑换记录
export function getnewTask () {
  return request({
    url: '/hr/newbietask/fetchAll',
    method: 'GET',
  })
}